import { Card as MantineCard, type CardProps as MantineCardProps } from '@mantine/core';
import { forwardRef } from 'react';

export type CardProps = MantineCardProps;

export const Card = forwardRef<HTMLDivElement, CardProps>(function Card(props, ref) {
  return <MantineCard ref={ref} withBorder shadow="sm" padding="md" radius="md" {...props} />;
});
